<template>
    <div class="main-body">
        <div class="header">
            盘点列表
        </div>
        <div class="out">

            <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">

                <el-table-column prop="waresName" label="物品名称" width="200" ></el-table-column>
                <el-table-column prop="stockCount" label="库存" width="200" ></el-table-column>
                <el-table-column prop="inventoryCount" label="盘点数" width="200" ></el-table-column>
                <el-table-column prop="createTime" :formatter="timefilter" width="200" label="日期"></el-table-column>
                <el-table-column prop="remarks" label="备注"></el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

            <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>
        </div>
    </div>
</template>

<script>
    import Info from "./Info";

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:false,
                showModalInfo:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
            }
        },
        components:{
            Info
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight+50;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){

                this.th = val+50;
            },
        },
        methods:{
            handleInfo(index, row) {
                this.$refs.myInfo.init(row);
                this.showModalInfo = !this.showModalInfo;
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            closeInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Inventory/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },


        }
    }
</script>

<style scoped>

</style>
